<script lang="ts">
    import { onMount, beforeUpdate, onDestroy } from 'svelte';

    export let artworkURL: string;
    let el: HTMLElement;
    let app: any;

    // This dynamic import is for performance.
    onMount(async () => {
        const NowPlayingScene = await import('./scene');
        app = new NowPlayingScene.default(el, artworkURL);
    });

    beforeUpdate(() => {
        if (app) {
            app.updateArtwork(artworkURL);
        }
    });

    onDestroy(() => {
        if (app) {
            app.destroy();
        }
    });
</script>

<div class="dt-now-playing__platter" data-testid="now-playing-backdrop">
    <canvas bind:this={el} />
</div>

<style lang="scss">
    .dt-now-playing__platter {
        width: 100%;
        height: 100%;
        position: absolute;
        overflow: hidden;
        pointer-events: none;
        border-radius: inherit;
        z-index: var(--z-default);

        canvas {
            width: 100%;
            height: 100%;
            display: block;
        }
    }
</style>
